import { createRouter, createWebHistory } from 'vue-router'
import BicycleComputer from '../pages/bicyclecomputer/BicycleComputer.vue'
import MapDownload from '../pages/mapDownload.vue'

const routes = [
 {
    path: '/',
    name: 'mapDownload',
    component: MapDownload
  },
  {
    path: '/bicyclecomputer',
    name: 'BicycleComputer',
    component: BicycleComputer
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router